import { containsUrl } from './contains-url';
import { isValidTelUrl } from './is-valid-te-url';

export const isValidUrl = (url?: string, options: { allowTelLink?: boolean } = {}): boolean =>
  !!url && (containsUrl(url) || !!(options.allowTelLink && isValidTelUrl(url)));
